import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/staticpage/";

const StaticPageApi = {
	getByDossier(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default StaticPageApi;
